import React from 'react';
import Box from '../Box/Box';

import TEBadgeSignal from '../../types/TEBadgeSignal';

type TBadge = {
  signal: TEBadgeSignal;
};

const Badge = ({ signal, ...rest }: TBadge) => <Box {...rest} as="div" name="Badge" modifiers={signal} />;

export default Badge;
